//banner图片轮播
$(function () {
  const $imgs = $(".app-img-swiper-item");
  if ($imgs.length > 1) {
    const $pagination = $('<div class="app-pagination-wrap"></div>');
    for (let i = 0; i < $imgs.length; i++) {
      $pagination.append(
        '<div class="app-pagination-item"><i class="white-box"></i></div>'
      );
    }
    $(".app-img-swiper-list").after($pagination);
  }
  //
  const $paginations = $(".app-pagination-wrap .app-pagination-item");
  //
  let activeIndex = 0;
  const activeSync = () => {
    if (!$imgs.get(activeIndex)) {
      activeIndex = 0;
    }
    $imgs.removeClass("active").eq(activeIndex).addClass("active");
    $paginations.removeClass("active").eq(activeIndex).addClass("active");
  };
  setTimeout(activeSync, 100);
  $paginations.on("click", function () {
    activeIndex = $paginations.index($(this));
    activeSync();
    restartInterval();
  });
  let interval = null;
  const restartInterval = () => {
    clearInterval(interval);
    interval = setInterval(() => {
      activeIndex++;
      activeSync();
    }, 5000);
  };
  restartInterval();
});

$(function () {
  const $imgs = $(".app-szxc-block .module-item .img-item");
  $imgs.each(function () {
    const $t = $(this);
    const $img = $t.find("img");
    const cImg = new Image();
    cImg.onload = () => {
      const canvas = $t.find("canvas").get(0);
      if (canvas) {
        canvas.width = 250;
        canvas.height = 140;
        const ctx = canvas.getContext("2d");
        const grd = ctx.createLinearGradient(0, 0, 0, $img.height());
        ctx.drawImage(cImg, 0, 0, $img.width(), $img.height());
        grd.addColorStop(0, "rgba(255,255,255,0.7)");
        grd.addColorStop(0.3, "rgba(255,255,255,0.7)");
        grd.addColorStop(1, "rgba(255,255,255,0)");
        ctx.fillStyle = grd;
        ctx.fillRect(0, 0, 250, 140);
      }
    };
    setTimeout(() => {
      cImg.src = $img.attr("src");
    }, 100);
  });
});
// 图片轮播
$(function () {
  const init = ($imgs) => {
    let leftIndex = 0;
    const classSync = () => {
      //重置每一张图片的class
      if (!$imgs.get(leftIndex)) {
        leftIndex = 0;
      }
      let middleIndex = leftIndex + 1;
      if (!$imgs.get(middleIndex)) {
        middleIndex = 0;
      }
      let rightIndex = middleIndex + 1;
      if (!$imgs.get(rightIndex)) {
        rightIndex = 0;
      }
      $imgs.removeClass("left middle right");
      $imgs.eq(leftIndex).removeClass("middle right").addClass("left");
      $imgs.eq(middleIndex).removeClass("left right").addClass("middle");
      $imgs.eq(rightIndex).removeClass("left middle").addClass("right");
    };
    const showNext = () => {
      //显示下一张图片
      leftIndex++;
      classSync();
    };
    classSync();
    //----------------------------------------------------------------------
    const showPrev = () => {
      //显示上一张图片
      leftIndex--;
      if (!$imgs.get(leftIndex)) {
        leftIndex = $imgs.length - 1;
      }
      classSync();
    };
    //--------------------------------------------------------------------------
    const $imgList = $imgs.parents(".img-list");
    const bindMouseMove = require("../../utils/bindMobileMove");
    bindMouseMove($imgList);
    let lastMoveTime = 0;
    $imgList.on("mouseLeftMove", () => {
      if ($.now() - lastMoveTime > 500) {
        showNext();
        lastMoveTime = $.now();
        restartInterval();
      }
    });
    $imgList.on("mouseRightMove", () => {
      if ($.now() - lastMoveTime > 500) {
        showPrev();
        lastMoveTime = $.now();
        restartInterval();
      }
    });
    // //点击某个图片 把它放到最中间
    // $imgs.on('click', function () {
    //   const middleIndex = $imgs.index($(this));
    //   console.log(middleIndex);
    //   leftIndex = middleIndex - 1;
    //   classSync();
    // });
    //
    const restartInterval = (() => {
      let interval = null;
      return () => {
        clearInterval(interval);
        interval = setInterval(showNext, 50000000);
      };
    })();
    restartInterval();
  };

  //数字乡村建设 图片轮播
  init($(".app-szxc-block .module-index-1 .img-item"));
  //村里办 图片轮播
  init($(".app-szxc-block .module-index-2 .img-item"));
  // 数字工厂  图片轮播
  init($(".app-szgc-block .img-list .img-item"));
});

// aiot
$(() => {
  const $wrap = $(".app-aiot-block .type-list"); //圆
  const $items = $wrap.find(".type-item"); //每个元素
  const length = $items.length; //元素个数
  const size = $wrap.width(); //圆的尺寸
  const radius = size / 2; //圆的半径
  const sRotate = (Math.PI * 2) / length; //每一个叠加旋转的角度
  //如果有偶数个 第一个旋转角度 sRotate*-0.5 否则 第一个就旋转角度
  const sp = length % 2 === 0 ? sRotate * -0.5 : 0;
  $items.each(function () {
    const $t = $(this);
    const index = $t.attr("data-index") * 1;
    const rotate = sp + (index - 1) * sRotate; //旋转的角度
    const x = Math.sin(rotate) * radius; //和圆心之间的距离---X方向
    const y = Math.cos(rotate) * radius; //和圆心之间的距离---Y方向
    const left = radius + x;
    const top = radius - y;
    $t.css({ left, top });
  });
});
// 行业应用
$(() => {
  let activeTitle = null; //标记当前选中的选项
  let activeSubTitle = null; //标记当前选中的子选项
  let activeTitle1 = null; //标记当前选中的选项
  let activeSubTitle1 = null; //标记当前选中的子选项
  // 设置每个 选项/子选项 的选中状态
  const activeSync = () => {
    //
    $(".app-industry-apply-block .sub-switch-list")
      .removeClass("show")
      .filter(`[data-title="${activeTitle}"]`)
      .addClass("show");
    //
    $(".app-industry-apply-block .switch-item")
      .removeClass("active")
      .filter(`[data-title="${activeTitle}"]`)
      .addClass("active");
    //
    $(".app-industry-apply-block .sub-switch-item")
      .removeClass("active")
      .filter(
        `.sub-switch-list[data-title="${activeTitle}"] .sub-switch-item[data-title="${activeSubTitle}"]`
      )
      .addClass("active");

    // 获取第二项应用标题
    $(".app-industry-apply-block .sub-switch-item1")
      .removeClass("active")
      .filter(
        `.sub-switch-list1[data-title="${activeTitle1}"] .sub-switch-item1[data-title="${activeSubTitle1}"]`
      )
      .addClass("active");
    //
    $(
      ".app-industry-apply-block .module-list .module-item .child-list .child-item"
    )
      .removeClass("active")
      .filter(
        `.module-item[data-title="${activeTitle}"] .child-item[data-title="${activeSubTitle}"]`
      )
      .addClass("active");

    //获取第二项应用内容
    $(
      ".app-industry-apply-block .module-list .module-item .child-list .child-item1"
    )
      .removeClass("active")
      .filter(
        `.module-item[data-title="${activeTitle1}"] .child-item1[data-title="${activeSubTitle1}"]`
      )
      .addClass("active");

    $(window).trigger("scroll");
  };
  //
  $(".app-industry-apply-block")
    .on("click", ".sub-switch-item", function (event) {
      //子选项被点击后 选中该子选项和它的父级选项
      event.stopPropagation();
      const $t = $(this);
      activeSubTitle = $t.attr("data-title");
      activeTitle = $t.parents(".sub-switch-list").attr("data-title");
      activeSync();
    })
    .on("click", ".sub-switch-item1", function (event) {
      //子选项被点击后 选中该子选项和它的父级选项
      event.stopPropagation();
      const $t = $(this);
      activeSubTitle1 = $t.attr("data-title");
      activeTitle1 = $t.parents(".sub-switch-list1").attr("data-title");
      activeSync();
    })
    .on("click", ".switch-item", function () {
      //选项被点击后 选中该选项和它的第一个子选项
      const $t = $(this);
      //   activeTitle = $t.attr("data-title");
      //   activeSubTitle = $(
      //     `.sub-switch-list[data-title="${activeTitle}"] .sub-switch-item`
      //   )
      //     .first()
      //     .attr("data-title");
      //   console.log(activeSubTitle);
      activeSync();
    })
    .find(".switch-item .sub-switch-item")
    .first()
    .trigger("click");
  // .find(".sub-switch-item")
  // .first()
  // .addClass("active"); //默认选中第一个选项
  // 默认选中第二项数组的第一项
  $(".app-industry-apply-block")
    .find(".sub-switch-item1")
    .first()
    .trigger("click"); //默认选中第一个选项
});
// 合作共赢
$(() => {
  $(".app-cooperate-block .group-switch")
    .on("click", ".switch-item", function () {
      //
      $(".app-cooperate-block .group-switch .switch-item").removeClass(
        "active"
      );
      $(".app-cooperate-block .group-list .group-item").removeClass("active");
      //
      const code = $(this).addClass("active").attr("data-code");
      $(
        `.app-cooperate-block .group-list .group-item[data-code="${code}"]`
      ).addClass("active");
      $(window).trigger("scroll");
    })
    .find(".switch-item")
    .first()
    .trigger("click");
});
